export default __webpack_public_path__ + "static/media/styleci.b50952c8.svg";